/*********************************************************
 * Copyright (C) 2016-2017 VMware, Inc. All rights reserved.
 *********************************************************/

/**
 * @fileoverview dialogservice.js -- dialogService
 * Service to decouple the dialog implementation from UI layer
 */

import RTAV from './logservice';

let dialogService = (() => {
   let uiDialogCallback;
   return {
      setDialogFunction: function(dialogFunction) {
         uiDialogCallback = dialogFunction;
      },
      showDialog: function(info, okCallback, cancelCallback) {
         if (typeof uiDialogCallback !== 'function') {
            RTAV.logService.devError('the uiDialogCallback doesn\'t exist');
            return;
         }
         uiDialogCallback(info, okCallback, cancelCallback);
      }
   };
})();

export default dialogService;